/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PaymentLinkPaginatedProperty =
  typeof PaymentLinkPaginatedProperty[keyof typeof PaymentLinkPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentLinkPaginatedProperty = {
  OWNER_NAME: 'OWNER_NAME',
  PAYMENT_DUE_DATE: 'PAYMENT_DUE_DATE',
  PAYMENT_DUE_AMOUNT: 'PAYMENT_DUE_AMOUNT',
  LINK_CREATED_AT: 'LINK_CREATED_AT',
} as const;
